import { render, staticRenderFns } from "./CustomerCategoryDiscount.vue?vue&type=template&id=abb853c2&"
import script from "./CustomerCategoryDiscount.vue?vue&type=script&lang=js&"
export * from "./CustomerCategoryDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports